<template>
  <modal
      name="confirmItemDelete"
      height="auto"
      width="400px"
  >
    <div class="window-header">
      {{ computedTitle }}
      <a href="javascript:void(0)" class="close-modal pull-right" @click="$modal.hide('confirmItemDelete')"><i
          class="fa fa-times"></i></a>
    </div>
    <div class="modal-body">
     {{msg}}
    </div>
    <div class="modal-footer">
      <button
          class="btn btn-primary"
          href="javascript:void(0);"
          v-on:click="deleteCurrentItem()"
          type="button"
      >
        <span>Yes, delete</span>
      </button>
      <button
          class="btn btn-default"
          href="javascript:void(0);"
          v-on:click="$modal.hide('confirmItemDelete')"
          type="button"
      >
        <span>Cancel</span>
      </button>
    </div>
  </modal>
</template>

<script>
import axios from "axios";
import {TokenMixin} from "@/assets/js/mixins/token-mixin";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: 'ModalConfirmItemDelete',
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  props: {
    url: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    msg: {
      type: String,
      default: "Are you sure you want to delete item?"
    }
  },
  computed: {
    computedTitle() {
      if (this.title === null) {
        return `Confirm item ${this.itemId} delete`
      }

      return this.title
    }

  },
  methods: {
    deleteCurrentItem() {
      let url = this.url + this.itemId;
      if (!url) {
        this.$emit('onError', 'Invalid params');
        return;
      }
      axios.delete(url, this.authRespConf())
          .then(() => {
            this.$modal.hide('confirmItemDelete');
            this.$emit('onComplete');
          })
          .catch((err) => {
            this.errorHandle(err, true, true);
            this.$modal.hide('confirmItemDelete');
            this.$emit('onError', err);
          });
    }
  }
}
</script>
